const orderAutorefreshInterval = parseInt(process.env.VUE_APP_ORDERS_AUTOREFRESH_INTERVAL || "45000");
export const orderAutorefreshIntervalNumber: number = isNaN(orderAutorefreshInterval) ? 45000 : orderAutorefreshInterval;